import React from 'react';
import CRUDList from '../Common/CRUDList';
import { currencies } from '../../services/api';
import { currencyTypes } from '../../constants/travelEnums';

function CurrencyForm({ formData, setFormData }) {
  return (
    <>
      <div className="form-group">
        <label>Currency Type *</label>
        <select
          value={formData.curr_type || ''}
          onChange={(e) => setFormData({ ...formData, curr_type: parseInt(e.target.value) })}
          required
        >
          <option value="">Select type</option>
          {Object.entries(currencyTypes).map(([key, value]) => (
            <option key={key} value={key}>{value}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Symbol Code *</label>
        <input
          type="text"
          value={formData.curr_symbol_code || ''}
          onChange={(e) => setFormData({ ...formData, curr_symbol_code: e.target.value })}
          maxLength={10}
          required
        />
      </div>

      <div className="form-group">
        <label>Number Code</label>
        <input
          type="number"
          value={formData.curr_number_code || ''}
          onChange={(e) => setFormData({ ...formData, curr_number_code: e.target.value ? parseInt(e.target.value) : null })}
        />
      </div>

      <div className="form-group">
        <label>Minor Units *</label>
        <input
          type="number"
          value={formData.curr_minor_units !== null && formData.curr_minor_units !== undefined ? formData.curr_minor_units : ''}
          onChange={(e) => setFormData({ ...formData, curr_minor_units: e.target.value !== '' ? parseInt(e.target.value) : null })}
          min={0}
          required
        />
      </div>
    </>
  );
}

function CurrenciesList() {
  return (
    <CRUDList
      title="Currencies"
      api={currencies}
      columns={['ID', 'Type', 'Symbol Code', 'Number Code', 'Minor Units']}
      FormComponent={CurrencyForm}
      defaultFormData={{ curr_type: 10, curr_symbol_code: '', curr_number_code: null, curr_minor_units: 2 }}
      useOldStyle={true}
      renderRow={(item) => (
        <>
          <td>{item.curr_id}</td>
          <td><span className="badge badge-info">{currencyTypes[item.curr_type]}</span></td>
          <td>{item.curr_symbol_code}</td>
          <td>{item.curr_number_code || '-'}</td>
          <td>{item.curr_minor_units}</td>
        </>
      )}
    />
  );
}

export default CurrenciesList;
